import { MediaRegistry } from './MediaRegistry';

import { AssetContainerTypes, SlideBackgroundModelTypeEnum } from 'js/src/client';
import { INVISIBLE_IMAGE_SOURCE_DATA } from 'js/src/libs/consts';

export type ResolvedImage = { url: string } | { error: string };

/** The still a vision model can be shown for a registered media item: an image's preview, a video's poster. */
export function mediaImageUrl(id: string): ResolvedImage {
    const mediaRegistry = MediaRegistry.getInstance();
    const mediaData = mediaRegistry.getItem(id);
    if (!mediaData) {
        return { error: `Error: Media with ID "${id}" not found in registry.` };
    }

    const representation = mediaRegistry.getRepresentation(id);
    if (!representation) {
        return { error: `Error: Could not get representation for media ID "${id}".` };
    }

    // The "invisible" asset is a transparent placeholder used to show the
    // scene background - there's nothing meaningful to look at.
    if (
        mediaData.type === AssetContainerTypes.BACKGROUND &&
        mediaData.background?.type === SlideBackgroundModelTypeEnum.IMAGE &&
        mediaData.background?.image?.source === INVISIBLE_IMAGE_SOURCE_DATA.source &&
        mediaData.background?.image?.source_id === INVISIBLE_IMAGE_SOURCE_DATA.source_id
    ) {
        return {
            error: `Error: Media with ID "${id}" is an invisible/transparent image (effectively unset).`,
        };
    }

    if (representation.type === 'image' && mediaData.background?.image?.preview_url) {
        return { url: mediaData.background.image.preview_url };
    }
    if (representation.type === 'video' && mediaData.background?.video?.poster_url) {
        return { url: mediaData.background.video.poster_url };
    }
    const expectedField = representation.type === 'video' ? 'poster_url' : 'preview_url';
    return { error: `Error: Could not extract ${expectedField} from media ID "${id}".` };
}
